module.exports = __webpack_public_path__ + "img/GALLERY-SWIFT-3.2dec83a3.jpg";